import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["zIndex", "value", "theme"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getNanoProgressColor } from './theme/nanoProgressThemeOperators';
import themePropType from '../utils/themePropType';
import { jsx as _jsx } from "react/jsx-runtime";
const Bar = styled.div.withConfig({
  displayName: "VizExNanoProgress__Bar",
  componentId: "sc-1ds1ap3-0"
})(["transition:width 0.2s ease-in-out;left:0;position:absolute;top:0;opacity:", ";width:", ";height:3px;z-index:", ";background-color:", ";"], ({
  value
}) => value === 0 ? 0 : 1, ({
  value
}) => `${value}%`, ({
  zIndex
}) => zIndex, ({
  theme
}) => getNanoProgressColor(theme));
const VizExNanoProgress = _ref => {
  let {
      zIndex = 10,
      value = 0,
      theme
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Bar, Object.assign({}, rest, {
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": value,
    role: "progressbar",
    zIndex: zIndex,
    value: value,
    theme: theme
  }));
};
VizExNanoProgress.propTypes = {
  theme: themePropType,
  value: PropTypes.number,
  zIndex: PropTypes.number
};
VizExNanoProgress.displayName = 'VizExNanoProgress';
export default VizExNanoProgress;